export const environment = {
  production: true,
  appName: 'billtrust',
};
